export function removeUndefinedValues(obj: any): any {
  return Object.fromEntries(Object.entries(obj).filter(([_key, value]) => typeof value !== 'undefined'));
}
